import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeLanguage } from 'actions/localization';

let langList = [];

switch (COUNTRY) {
  case 'LV':
    langList = [
      { locale: 'lv', label: 'LV' },
      { locale: 'ru', label: 'RU' },
    ];
    break;
  case 'FI':
    langList = [
      { locale: 'fi', label: 'FI' },
      { locale: 'en', label: 'EN' },
    ];
    break;
  case 'EE':
    langList = [
      { locale: 'et', label: 'EE' },
      { locale: 'ru', label: 'RU' },
    ];
    break;
  case 'MX':
    langList = [
      { locale: 'es', label: 'ES' },
      { locale: 'en', label: 'EN' },
    ];
    break;
  case 'LT':
    langList = [
      { locale: 'lt', label: 'LT' },
      { locale: 'en', label: 'EN' },
    ];
    break;
  default:
    langList = [
      { locale: 'en', label: 'EN' },
    ];
}

const propTypes = {
  changeLanguage: PropTypes.func,
  intl: PropTypes.object,
  authentication: PropTypes.object,
};

class LanguageSwitcher extends React.Component {
  constructor() {
    super();
    this.switchLanguage = this.switchLanguage.bind(this);
  }

  switchLanguage(e) {
    const lang = e.target.value;
    this.props.changeLanguage(lang);
  }

  render() {
    const { authentication } = this.props;
    if (!authentication.isAuthenticated && !authentication.isRegConfirmationNeeded) {
      return (
        <span className="language-switcher select select--size-small select--type-header pull-right">
          <span className="select__field-wrapper">
            <select
              className="language-switcher__field select__field"
              value={this.props.intl.locale}
              onChange={this.switchLanguage}
            >
              {langList.map((item) =>
                <option value={item.locale} key={item.locale}>{item.label}</option>)}
            </select>
          </span>
        </span>
      );
    }
    return null;
  }
}

LanguageSwitcher.propTypes = propTypes;

export default connect(
  (state) => ({
    intl: state.intl,
    authentication: state.authentication,
  }),
  { changeLanguage }
)(LanguageSwitcher);
